<template>
  <div class="comm_input_area">
    <div class="ing" v-if="selectedComment">
      <p>'{{ selectedComment.writer }}'님에게 답글 남기는중</p>
      <i class="i_x pnt" @click="close"></i>
    </div>
    <div class="input_box">
      <div class="toggle_box" v-if="isAnonymous">
        <p>익명</p>
        <div class="toggle_switch">
          <input
            type="checkbox"
            id="switch"
            v-model="form.isAnonymous"
            true-value="Y"
            false-value="N"
          /><label class="pnt" for="switch"></label>
        </div>
      </div>
      <label class="comment_box">
        <textarea
          ref="textarea"
          placeholder="답글을 입력해주세요"
          rows="1"
          v-model.trim="form.content"
          maxlength="500"
          @keyup="handleTextarea"
        />
        <button type="submit" @click="onSubmit">
          등록
        </button>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'component-community-detail-input-comment',
  description: '커뮤니티 > 답글 작성 영역',
  props: {
    isAnonymous: {
      type: Boolean,
      default: false,
    },
    selectedComment: [String, Object],
  },
  data() {
    return {
      form: {
        boardId: this.$route.params.id,
        isAnonymous: 'N',
        content: '',
      },
    };
  },
  methods: {
    handleTextarea() {
      const textarea = this.$refs.textarea;
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
    },
    onSubmit() {
      if (!this.form.content) return;
      this.$emit('submit', this.form);
      this.$refs.textarea.style.height = '3.9rem';
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style></style>
